export default "__VITE_ASSET__rrS6aofx__"